import React, { useContext } from 'react';
import clsx from 'clsx';
import { objectKeys } from 'src/utils/objectKeys';
import { MatchType, VarianceType } from '../types/AlertResults';
import { SidebarFilters, AlertResultsContext } from '../AlertResultsProvider';
import { AlertResultsFiltersState } from '../hooks/useAlertResultsFiltersFetch';
import { FilterSelect } from './FiltersSelect';
import styles from './AlertResultsFilters.module.less';

enum MatchTypeLabel {
  ALL = 'All Matches',
  EXACT = 'Exact Matches',
  LIKE = 'Smart Matches',
}

enum VarianceTypeLabel {
  Lowest = 'Lowest Price',
  Regular = 'Regular Price',
}

type SidebarFilterKeys = 'clientRegions' | 'competitorSellers' | 'competitorFulfillers' | 'competitorSites';
export type SidebarFilter = Pick<AlertResultsFiltersState, SidebarFilterKeys>;

type FiltersFormProps = {
  filters: SidebarFilter;
};

const matchTypeOptions = objectKeys(MatchType).map((item) => ({ value: MatchType[item], label: MatchTypeLabel[item] }));
const varianceTypeOptions = objectKeys(VarianceType).map((item) => ({ value: VarianceType[item], label: VarianceTypeLabel[item] }));
export const FiltersForm: React.FC<FiltersFormProps> = ({ filters }) => {
  const { clientRegions, competitorSellers, competitorFulfillers, competitorSites } = filters;
  const { headerFilters, sidebarFilters, changeSidebarFilters } = useContext(AlertResultsContext);

  const competitorSitesOptions = competitorSites.map((item) => ({ value: item.ownerId, label: item.ownerName }));

  const isDisabled = !headerFilters.alertId || !headerFilters.sourceSiteId || !headerFilters.insertionDate;

  const handleFieldChange = <T extends keyof SidebarFilters>(value: SidebarFilters[T], filterKey: T) => {
    changeSidebarFilters(value, filterKey);
  };

  return (
    <div className={clsx(styles.form, 'widget_color')}>
      <FilterSelect
        defaultValue={MatchType.ALL}
        value={sidebarFilters.matchType}
        label="Match Type"
        options={matchTypeOptions}
        onChange={(value) => handleFieldChange(value as MatchType, 'matchType')}
        disabled={isDisabled}
      />
      <FilterSelect
        defaultValue={VarianceType.Lowest}
        value={sidebarFilters.priceType}
        label="Variance Type"
        options={varianceTypeOptions}
        onChange={(value) => handleFieldChange(value as VarianceType, 'priceType')}
        disabled={isDisabled}
      />
      <FilterSelect
        value={sidebarFilters.clientRegion}
        label="Source Region"
        options={clientRegions}
        onChange={(value) => handleFieldChange(value, 'clientRegion')}
        disabled={isDisabled}
      />
      <FilterSelect
        value={sidebarFilters.competitorSiteId}
        label="Competitor Site"
        options={competitorSitesOptions}
        onChange={(value) => handleFieldChange(value, 'competitorSiteId')}
        disabled={isDisabled}
      />
      <FilterSelect
        value={sidebarFilters.competitorSellerName}
        label="Competitor Seller"
        options={competitorSellers}
        onChange={(value) => handleFieldChange(value, 'competitorSellerName')}
        disabled={isDisabled}
      />
      <FilterSelect
        value={sidebarFilters.competitorFulfillerName}
        label="Competitor Fulfiller"
        options={competitorFulfillers}
        onChange={(value) => handleFieldChange(value, 'competitorFulfillerName')}
        disabled={isDisabled}
      />
    </div>
  );
};
